import { Loader } from 'components/Loader/Loader';
import { Dayjs } from 'dayjs';
import React, { useState } from 'react';
import { CalendarFetchByDay } from '../../../../components/OrderListTable/CalendarFetch/CalendarFetchByDay';
import { useGetPerformanceScanList } from '../../../../hooks/useGetPerformanceScanList';
import { Region } from '../../../../types/orderTypes';
import { ScanMenuButtons } from '../ScanMenuButtons/ScanMenuButtons';
import { ScanPerformanceListComponent } from '../ScanPerformanceListComponent/ScanPerformanceListComponent';
import { ScansTotalRemainingComponent } from '../ScansTotalRemaining/ScansTotalRemaining';
import { showDayByHourOfDay } from '../showDayByHourOfDay';
import './ScanPerformanceLeaderboard.scss';
import { Helmet } from 'react-helmet';

export function ScanPerformanceLeaderboard({
  region,
}: {
  region: Region;
}): JSX.Element {
  const dayToSHow: Dayjs = showDayByHourOfDay();
  const [startDate, setStartDate] = useState(dayToSHow);

  const { performanceScanList, isLoading } = useGetPerformanceScanList(
    startDate,
    startDate
  );

  const fetchValues = (givenDate: Dayjs) => {
    setStartDate(givenDate);
  };

  return (
    <div className="ScanPerformanceLeaderboard-Layout">
      <Helmet>
        <title>Monitor - Scan Leaderboard</title>
      </Helmet>
      <ScanMenuButtons />

      <CalendarFetchByDay
        fetchValues={fetchValues}
        givenDate={startDate}
        trackingName={'Leaderboard-scan'}
      />
      {isLoading === true && (
        <div className={'loading'}>
          <Loader type="spinner" size="large" />
        </div>
      )}
      {isLoading === false && (
        <>
          <div className="ScanPerformanceLeaderboard">
            <div className="InfoTopRow">
              <ScansTotalRemainingComponent forDate={startDate} />{' '}
            </div>

            <ScanPerformanceListComponent
              performanceScanList={performanceScanList}
              isLeaderBoard={true}
            />
          </div>
        </>
      )}
    </div>
  );
}
